function FakeBackendForAvailableColumnsInLeft() {
    return (
        {
            "content": [
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 3,
                    "columnName": "MATERIAL_DESC",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 4,
                    "columnName": "MAKER_PART_NO",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 5,
                    "columnName": "CUSTOMER_PART_NO",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 7,
                    "columnName": "BUYERS_ORDER_NO",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 8,
                    "columnName": "BUYERS_ORDER_LINE_NO",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 10,
                    "columnName": "SALES_ORDER_LINE_NO",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 12,
                    "columnName": "UNIT_PRICE_BASIS_QTY",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 14,
                    "columnName": "INVOICE_AMOUNT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 15,
                    "columnName": "TAX_TYPE1",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 16,
                    "columnName": "TAX_RATE1",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 17,
                    "columnName": "TAXABLE_AMOUNT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 18,
                    "columnName": "TAX_AMOUNT1",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 19,
                    "columnName": "TAX_TYPE2",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 20,
                    "columnName": "TAX_RATE2",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 21,
                    "columnName": "TAX_AMOUNT2",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 22,
                    "columnName": "INVOICE_NUMBER",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 23,
                    "columnName": "INVOICE_TYPE",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 24,
                    "columnName": "INVOICE_DT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 25,
                    "columnName": "SHIPMENT_DT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 26,
                    "columnName": "PAYMENT_TERMS",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 27,
                    "columnName": "DESPATCH_NOTE_NO",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 28,
                    "columnName": "DESPATCH_NOTE_NO",
                    "process": {
                        "process": "vendor_bp_code",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 29,
                    "columnName": "CUSTOMER_BP_CODE",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 32,
                    "columnName": "TOTAL_AMOUNT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 34,
                    "columnName": "TOTAL_TAX_AMOUNT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 35,
                    "columnName": "TAX_RATE",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 36,
                    "columnName": "COUNTRY_OF_ORIGIN",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 37,
                    "columnName": "APPROVED_FLAG",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 38,
                    "columnName": "APPROVED_DT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 39,
                    "columnName": "APPROVED_BY",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 40,
                    "columnName": "STATUS_FLAG",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 41,
                    "columnName": "STATUS_MESSAGE",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 42,
                    "columnName": "CREATED_DT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 43,
                    "columnName": "UPDATED_DT",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 44,
                    "columnName": "UPDATED_BY",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 45,
                    "columnName": "LAST_SYNC_TIME",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 46,
                    "columnName": "ORGANIZATION_ID",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                },
                {
                    "createdBy": "ADMIN",
                    "createdTime": "2021-06-03",
                    "updatedBy": null,
                    "updatedTime": "2021-06-09",
                    "active": true,
                    "createdDtDisp": "03-06-2021",
                    "lastUpdatedDtDisp": "09-06-2021",
                    "id": 47,
                    "columnName": "INVOICE_HDR",
                    "process": {
                        "process": "Invoice",
                        "processId": 5
                    },
                }
            ],
            "pageable": {
                "sort": {
                    "sorted": true,
                    "unsorted": false,
                    "empty": false
                },
                "offset": 0,
                "pageSize": 25,
                "pageNumber": 0,
                "paged": true,
                "unpaged": false
            },
            "totalElements": 1,
            "last": true,
            "totalPages": 1,
            "size": 25,
            "number": 0,
            "sort": {
                "sorted": true,
                "unsorted": false,
                "empty": false
            },
            "numberOfElements": 1,
            "first": true,
            "empty": false
        }
    )
}
export default FakeBackendForAvailableColumnsInLeft;